import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IDynamoEmployee } from './update-employee';
import { Observable } from 'rxjs';
import { IEmployee } from '../../classes/IEmployee';

@Injectable({
    providedIn: 'root'
})
export class EmployeeService {
    private baseUrl = environment.apiUrls.employee;

    constructor(private http: HttpClient) {}

    public updateUser(employee: IDynamoEmployee) {
        const url = `${this.baseUrl}`;
        return this.http.put(url, employee);
    }

    public getEmployees(): Observable<IEmployee[]> {
        const url = `${this.baseUrl}`;
        return this.http.get<IEmployee[]>(url);
    }

    public getEmployee(gid: string): Observable<IEmployee> {
        const url = `${this.baseUrl}/${gid}`;
        return this.http.get<IEmployee>(url);
    }
}
